import { api } from '../../core/network/api';

/** design/gdd/commissions.md REST surface — plain wrappers, same convention as contracts-api.ts. */

export type CommissionTier = 'COMMON' | 'SHALLOW' | 'DEEP';

export interface CommissionRow {
  defId: string;
  patron: string;
  title: string;
  flavour: string;
  tier: CommissionTier;
  itemDefId: string;
  itemName: string;
  count: number;
  /** How many of the wanted item this account is holding right now. */
  held: number;
  payoutWax: number;
  /** What the vendor would pay for the same items — what the payout is worth comparing to. */
  vendorWax: number;
  surplusWax: number;
  askWeightKg: number;
  delivered: boolean;
}

export interface CommissionBoardResponse {
  /** ISO timestamp the board rotates. */
  expiresAt: string;
  commissions: CommissionRow[];
}

export const getCommissions = (): Promise<CommissionBoardResponse> => api.get('/commissions');

export const deliverCommission = (defId: string): Promise<{
  defId: string; paidWax: number; itemsDelivered: number; softBalance: number;
}> => api.post('/commissions/deliver', { defId });
